"use client";

import { Form, Input, Button, Typography, message } from "antd";
import Cookies from "js-cookie";
import service from "../api/FetchInterceptor";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import logo from '../assets/images/LOGO_DNC.jpeg'

const { Title, Paragraph } = Typography;

const Login = () => {
    const [form] = Form.useForm();

    const [step, setStep] = useState("login"); // "login" | "2fa"
    const [challengeId, setChallengeId] = useState(null);
    const [otp, setOtp] = useState("");

    const navigate = useNavigate()

    const onLogin = async (values) => {
        try {
            const response = await service({
                method: "POST",
                url: "login",
                data: values,
            });

            if (response.requires_2fa) {
                message.info(response.message || "Code envoyé par email.");
                setChallengeId(response.challenge_id);
                setStep("2fa");
                return;
            }

            Cookies.set("token", response.token, {
                expires: 7,
                secure: process.env.NODE_ENV === "production",
                sameSite: "strict",
                path: "/",
            });

            message.success("Connexion réussie !");
            navigate("/dashboard");
        } catch (error) {
            message.error(error.response?.data?.message || "Erreur de connexion");
        }
    };

    const onVerifyOtp = async () => {
        if (!otp.trim() || otp.trim().length !== 6) {
            message.warning("Saisis un code à 6 chiffres.");
            return;
        }

        try {
            const response = await service({
                method: "POST",
                url: "login/2fa",
                data: {
                    challenge_id: challengeId,
                    code: otp.trim(),
                },
            });

            Cookies.set("token", response.token, {
                expires: 7,
                secure: process.env.NODE_ENV === "production",
                sameSite: "strict",
                path: "/",
            });

            message.success("Connexion réussie !");
            navigate("/dashboard");
        } catch (error) {
            message.error(error.response?.data?.message || "Code invalide");
        }
    };



    return (
        <div className="flex flex-col min-h-screen items-center justify-center md:bg-blue-50">
            <img src={logo} alt="Espace AC | DNC" className="w-50 -mt-32" />

            <div className="w-full max-w-xl mx-4 p-6 rounded-lg bg-white mt-8 shadow">
                <Title level={3}>Connectez-vous</Title>

                <Paragraph>
                    Connectez-vous pour accéder aux offres d'emploi proposées par nos
                    entreprises partenaires.
                </Paragraph>

                {step === "login" ? (
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onLogin}
                        className="mt-4"
                    >
                        <Form.Item
                            label="Adresse e-mail"
                            name="email"
                            rules={[
                                { required: true, message: "L'adresse email est requise" },
                                { type: "email", message: "L'adresse email n'est pas valide" },
                            ]}
                        >
                            <Input placeholder="Entrez votre email" size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Mot de passe"
                            name="password"
                            rules={[
                                { required: true, message: "Le mot de passe est requis" },
                                {
                                    min: 8,
                                    message: "Le mot de passe doit contenir au moins 8 caractères",
                                },
                            ]}
                        >
                            <Input.Password placeholder="Entrez votre mot de passe" size="large" />
                        </Form.Item>

                        <Button type="primary" htmlType="submit" size="large" block>
                            Connexion
                        </Button>

                        <Button
                            type="link"
                            className="mt-2 px-0"
                            onClick={() => navigate("/forgot-password")}
                        >
                            Mot de passe oublié ?
                        </Button>
                    </Form>
                ) : (
                    <div className="mt-4">
                        <Paragraph>
                            Entre le code à 6 chiffres envoyé à ton adresse email.
                        </Paragraph>

                        <Input
                            size="large"
                            placeholder="Code 2FA (6 chiffres)"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                            onPressEnter={onVerifyOtp}
                        />

                        <div className="mt-4">
                            <Button type="primary" size="large" onClick={onVerifyOtp}>
                                Vérifier
                            </Button>
                            <Button
                                size="large"
                                onClick={() => {
                                    setStep("login");
                                    setChallengeId(null);
                                    setOtp("");
                                }}
                            >
                                Retour
                            </Button>
                        </div>
                    </div>
                )}
            </div>

            <Button
                type="link"
                className="mt-2"
                onClick={() => navigate("/verifier")}
            >
                Vérifier l'authenticité d'un document
            </Button>
        </div>
    );
}

export default Login